import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/team-members/api-integration/loading';
import { getTeamMemberQueryOption } from '@/_pages/team-members/api-service';

export const Route = createFileRoute('/_private/team-members/_template/$id/api-integration')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getTeamMemberQueryOption(opts.params.id)),
  staticData: {
    pageTitle: 'API Integrations',
    tabKey: 'team-member/api-integration',
  },
  pendingComponent: Loading,
});
